import { Skeleton } from '@/common/components/ui/skeleton';

export function ProductDetailSkeleton() {
  return (
    <>
      <div className="px-6 pt-6 pb-5 border-b border-gray-100 shrink-0">
        <Skeleton className="size-12 rounded-xl mb-4" />
        <Skeleton className="h-6 w-48 mb-2" />
        <Skeleton className="h-5 w-20" />
      </div>
      <div className="flex-1 px-6 py-5 space-y-6">
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
        <div className="space-y-2">
          {[...Array(4)].map((_, i) => (
            <Skeleton key={i} className="h-10 w-full" />
          ))}
        </div>
        <div className="space-y-2">
          {[...Array(3)].map((_, i) => (
            <Skeleton key={i} className="h-5 w-full" />
          ))}
        </div>
      </div>
    </>
  );
}
